import { Helmet } from 'react-helmet-async';
import { Link } from 'react-router-dom';

export default function Page404() {
  return (
    <>
      <Helmet>
        <title>404 Page Not Found | agrantis</title>
      </Helmet>

      <div>
        <div className="max-w-[480px] m-auto min-h-100vh flex justify-center flex-col text-center items-center">
          <p className="text-3-0 font-bd mb-2-0">Sorry, page not found!</p>
          <p className="text-1-6 color-grey-400">
            Sorry, we couldn’t find the page you’re looking for. Perhaps you’ve
            mistyped the URL? Be sure to check your spelling.
          </p>
          <img
            src="/illustrations/illustration_404.svg"
            className="h-26-0 mx-auto my-4-0 md:my-8-0"
          />
          <Link to="/">
            <span className="min-w-[64px] py-1-6 px-2-2 rounded-4-0 bg-primary-mouseovers text-white font-bd text-1-6 hover:bg-blue-300 shadow-md">
              Go To Home
            </span>
          </Link>
        </div>
      </div>
    </>
  );
}
